/**
 * @param input a {@link DetectionStatusChange} object
 * @returns true if the `DetectionStatusChange` should be rendered in the UI
 */
export const shouldRenderDetectionStatusChange = ({
    source,
}: DetectionStatusChange | ManageDetectionsStatusChange): boolean =>
    source === 'CLIENT' || source === 'ADMIN';
